import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/site";

const nav = [
  { label: "Home", to: "/" },
  { label: "Residential Cleaning", to: "/residential-cleaning" },
  { label: "Commercial Cleaning", to: "/commercial-cleaning" },
  { label: "NDIS & Aged Care", to: "/ndis-aged-care-cleaning" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

const services = [
  { label: "Domestic Cleaning", to: "/residential-cleaning" },
  { label: "Deep Cleaning", to: "/residential-cleaning" },
  { label: "End-of-Lease Cleaning", to: "/residential-cleaning" },
  { label: "Airbnb Cleaning", to: "/residential-cleaning" },
  { label: "Office Cleaning", to: "/commercial-cleaning" },
  { label: "Strata Cleaning", to: "/commercial-cleaning" },
  { label: "NDIS Cleaning", to: "/ndis-aged-care-cleaning" },
  { label: "Aged Care Cleaning", to: "/ndis-aged-care-cleaning" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-800 text-slate-300">
    <div className="container-site grid gap-12 py-16 sm:py-20 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-3">
          <img
            src="/images/logo.webp"
            alt="Oz SpotNest Cleaning Service logo"
            className="h-12 w-12 rounded-full bg-white object-cover"
            loading="lazy"
          />
          <span className="leading-tight">
            <span className="block font-heading text-lg font-bold text-white">Oz SpotNest</span>
            <span className="block text-[10px] font-semibold uppercase tracking-[0.28em] text-emerald-400">
              Cleaning Service
            </span>
          </span>
        </div>
        <p className="mt-5 text-sm leading-relaxed text-slate-400">
          Professional residential, commercial and specialised cleaning services across {BUSINESS.area}.
        </p>
        <p className="mt-4 font-heading text-sm font-semibold italic text-emerald-400">{BUSINESS.tagline}</p>
        <Link to="/contact" data-testid="footer-quote-button" className="btn-primary mt-6 !px-6 !py-3 text-sm">
          Get a Free Quote
        </Link>
      </div>

      <nav aria-label="Footer navigation">
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white">Explore</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {nav.map((l) => (
            <li key={l.label}>
              <Link to={l.to} className="transition-colors hover:text-emerald-400">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="Services">
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white">Services</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {services.map((l) => (
            <li key={l.label}>
              <Link to={l.to} className="transition-colors hover:text-emerald-400">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-white">Contact</h3>
        <ul className="mt-5 space-y-4 text-sm">
          <li>
            <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 transition-colors hover:text-emerald-400">
              <Phone className="h-4 w-4 shrink-0 text-emerald-400" /> {BUSINESS.phone}
            </a>
          </li>
          <li>
            <a href={BUSINESS.emailHref} data-testid="footer-email-link" className="flex items-center gap-3 break-all transition-colors hover:text-emerald-400">
              <Mail className="h-4 w-4 shrink-0 text-emerald-400" /> {BUSINESS.email}
            </a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
            <span>
              {BUSINESS.address}
              <br />
              Serving {BUSINESS.area}
            </span>
          </li>
          <li className="flex items-center gap-3">
            <Clock className="h-4 w-4 shrink-0 text-emerald-400" /> {BUSINESS.hours}
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container-site flex flex-col items-center justify-between gap-4 py-6 pb-24 text-xs text-slate-400 sm:flex-row md:pb-6">
        <p data-testid="footer-copyright">© {BUSINESS.year} {BUSINESS.fullName}. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy-policy" data-testid="footer-privacy-link" className="transition-colors hover:text-emerald-400">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" data-testid="footer-terms-link" className="transition-colors hover:text-emerald-400">
            Terms & Conditions
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
